import request from '@/utils/Request'
import { PaginateMeta } from '@/actions/paginate'

export type ProfileResponse = {
  user: {
    scrambled_id: number
    zero_padding_scrambled_id: string
    email: string
    first_name: string
    first_name_kana: string
    last_name: string
    last_name_kana: string
    birth_month: number | null
    birth_year: number | null
    gender: 1 | 2 | 3 | null
    postal_code: string,
    phone_number: string,
    store_id: number | null,
    prefecture_id: number | null,
    brand_id: number | null,
    nickname: string | null,
    address_prefecture_id: number | null,
    address: string | null,
    occupation: string | null,
    building_room: string | null,
    is_united_user: boolean,
    mail_flg: number | null
  }
}

export async function profile() {
  return await request.get<ProfileResponse>(`/mypage/profile`)
}
